import React from "react"

export const ChevronIcon = ({
  rotation = "down",
  size = 1,
  color = "#034055",
  stroke_width = "2",
}) => {
  const rotiations = {
    down: 90,
    up: -90,
    left: 180,
    right: 0,
  }

  return (
    <svg
      width={16 * size}
      height={16 * size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginBottom: "auto",
        marginTop: "auto",
        // marginBottom: (7 * size) / 2,
        transform: `rotate(${rotiations[rotation]}deg)`,
        transition: "all 0.2s ease",
        overflow: "visible",
        enableBackground: "new 0 0 16 16",
      }}
    >
      <polyline
        fill="none"
        stroke={color}
        strokeWidth={stroke_width}
        strokeMiterlimit="10"
        points="6,0 14,8 6,16 "
      />
    </svg>
  )
}
